// extracted by mini-css-extract-plugin
module.exports = {"startPageBoxFooter":"styles_startPageBoxFooter__Rdkc-","alignCenter":"styles_alignCenter__3-XCH","alignRight":"styles_alignRight__3iaMB","alignLeft":"styles_alignLeft___HmUF"};